import React from 'react';
import {
  Link, Row, Col, Typography, Spin, Alert, LeftCircleOutlined, useTranslation,
} from '@lib/index';
import useConfirmEmail from '../controller/useConfirmEmail';

const ConfirmEmail = () => {
  const { Title } = Typography;
  const { t } = useTranslation();
  const { status, uname } = useConfirmEmail();

  const alertProps = {
    success: { type: 'success' as const, message: t('login.confirmEmailSuccess') },
    merge: { type: 'info' as const, message: t('login.confirmEmailMerge', { uname }) },
    not_authorized: { type: 'error' as const, message: t('login.confirmEmailError') },
  };

  return (
    <div className="bg-login-bg bg-no-repeat bg-cover h-full bg-center p-24 shadow-inner">
      <Row align="middle" justify="center" className="mt-0">
        <Col xs={12} sm={12} md={12} lg={12} xl={7} className="mt-0">
          <Link to="/" className="text-white text-3xl">
            <LeftCircleOutlined className="text-white text-4xl pr-8" />
            {t('login.backToLogin')}
          </Link>
          <div className="p-12 mt-4 h-full w-full bg-white" data-cy="confirm-email">
            <Title type="secondary" className="text-center" level={4}>
              {t('login.confirmEmailTitle')}
            </Title>
            {status === 'loading' ? (
              <div className="text-center">
                <Spin size="large" />
                <p>{t('login.confirmEmailLoading')}</p>
              </div>
            ) : (
              <Alert
                type={alertProps[status].type}
                message={alertProps[status].message}
                showIcon
                data-cy="confirm-email-result"
              />
            )}
          </div>
          <div className="bg-logo-bg bg-no-repeat bg-center h-60 bg-auto" />
        </Col>
      </Row>
    </div>
  );
};
export default ConfirmEmail;
